/** App context value sent as messageAnnotationAppContext for calendar event drafting scenarios */
export const CALENDAR_EVENT_DRAFTING_APP_CONTEXT = 'CalendarEventDrafting';

/**
 * App context value sent as messageAnnotationAppContext when the user is on the calendar
 * surface (the grid, or viewing/selecting an existing event) but not drafting a new event.
 */
export const CALENDAR_SURFACE_APP_CONTEXT = 'CalendarSurface';
